export default {
  priceIncreaseMany({
                      items = [],
                      price_increase_percentage = null,
                      effective_from = null,
                      increase_mode = null,
                      message = null,
                    }) {
    return axios.post(`${ import.meta.env.VITE_SITE_URL }/crms/agreements/price-increases/many`, {
      agreement_original: items,
      price_increase_percentage,
      effective_from,
      increase_mode,
      message,
    });
  },
  priceIncreaseAll({
                     items = [],
                     price_increase_percentage = null,
                     effective_from = null,
                     increase_mode = null,
                     message = null,
                   }) {
    return axios.post(`${ import.meta.env.VITE_SITE_URL }/crms/agreements/price-increases/all`, {
      ignore_agreement_original: items,
      price_increase_percentage,
      effective_from,
      increase_mode,
      message,
    });
  },
};
